module.exports = {
  // 字体切换
  zh:'中',
  en:'英',
  // 公司名称
  companyName: '珠海市颢腾智胜科技有限公司',
  companyNameMacao: '颢腾科技发展有限公司（澳门）',
  companyNameHongKong: '香港颢腾科技有限公司',
  // 面包屑
  Home:'网站首页',
  AboutUs:'关于我们',
  News: '新闻动态',
  ShowProgram:'方案展示',
  development:'软件定制化开发',
  VideoTechnology:'视频技术',
  SDT:'大数据技术',
  IBMS:'系统集成',
  Jobs:'招贤纳士',
  viewMore:'查看更多',
  Project: '产品展示',
  //导航
  nav: [
    {
      name: "网站首页",
      href: "/",
    },
    // {
    //   name: "新闻动态",
    //   href: "/News"
    // },
    {
      name: "产品展示",
      href: "/productDisplay"
    },
    {
      name: "招贤纳士",
      href: "/recruitment"
    },
    {
      name: "关于我们",
      href: "/mainAboutUs"
    },
  ],
  //新闻动态
  newsTrends:[
    {id:'05',date:'2019-05-30',title:'看数字广告如何阐述“生活”哲学',content:'作为一名数字营销人员，较后一次思考如何利用网络媒体来突出客户产品的核心属性是在什么时候呢？或者是思考如何使用广告创意，以发挥广告位置的较大功能？当有新的广告活动出现时，我们往往把焦点放在广告位置的一些数据中，如人口统计、覆盖范围、成本等内容上。'},
    {id:'04',date:'2019-05-29',title:'移动广告的未来：定位是关键',content:'广告与消费者的相关程度往往与产生转换的可能性成正比。正是因为这个原因，行为定位、重新定位、广告内容的喜好和定制，以及其他类似技术，对数字营销人员都非常有吸引力。'},
    {id:'03',date:'2019-05-28',title:'中国首次摘得捷克动画电影节较佳广告金奖',content:'据悉，捷克第九届国际动画电影节（AniFest）于 近日在特克利策市举行。本届电影节以捷克动画先驱卡雷尔·泽曼（Karel Zeman）为主题，为纪念这位捷克木偶电影创始人的百年诞辰，电影节举办了名为“卡雷尔·泽曼――电影奇观”的国际会议，旨在通过分析卡雷尔·'},
    {id:'02',date:'2019-05-27',title:'看数字广告如何阐述“生活”哲学',content:'作为一名数字营销人员，较后一次思考如何利用网络媒体来突出客户产品的核心属性是在什么时候呢？或者是思考如何使用广告创意，以发挥广告位置的较大功能？当有新的广告活动出现时，我们往往把焦点放在广告位置的一些数据中，如人口统计、覆盖范围、成本等内容上。'},
    {id:'01',date:'2019-05-26',title:'移动广告的未来：定位是关键',content:'广告与消费者的相关程度往往与产生转换的可能性成正比。正是因为这个原因，行为定位、重新定位、广告内容的喜好和定制，以及其他类似技术，对数字营销人员都非常有吸引力。'},
  ],
  //产品展示
  productDisplay: [
    {img: require("@/assets/img/comm/banner_product5.jpg"), href:'/pd_v1', name: "软件定制化开发", introduce:"公司有Android APP开发、iOS APP开发、前端开发、后台开发、UE&UX设计、运维管理、测试工程师和产品经理等方向的优秀人力，有丰富的B/S，C/S等架构的实践开发经验，开发了众多的垂直领域的行业软件。这些软件具有组件化、低耦合等特点，可被快速应用于其他的行业。"},
    {img: require("@/assets/img/comm/banner_product2.jpg"), href:'/pd_v2',name: "视频技术", introduce: "公司视频技术方面有深厚的积累，特别是在智能交通和3D人脸两个方面。"},
    {img: require("@/assets/img/comm/banner_product3.jpg"), href:'/pd_v3',name: "大数据技术", introduce: "随着交通卡口的大规模联网，系统汇集了海量车辆通行记录信息。利用交通大数据和人工智能技术，可实时分析城市交通流量，调整红绿灯间隔，缩短车辆等待时间等举措，提升城市道路的通行效率。"},
    {img: require("@/assets/img/comm/banner_product4.jpg"), href:'/pd_v4',name: "系统集成", introduce: "由于现代化的智能建筑和建筑群体的不断涌现，综合布线和系统集成的适用场合和服务对象逐渐增多。目前主要有商业贸易型，综合办公类型，交通运输类型，新闻机构类型，工业企业的高科技业务楼等等；"},
  ],
  //产品1
  text1:[
    "公司有Android APP开发、iOS APP开发、前端开发、后台开发、UE&UX设计、运维管理、测试工程师和产品经理等方向的优秀人力，有丰富的B/S，C/S等架构的实践开发经验，开发了众多的垂直领域的行业软件。这些软件具有组件化、低耦合等特点，可被快速应用于其他的行业。" ,
    "其中，最典型的产品是“团餐生产管理ERP系统”，该系统当前版本采用B/S架构，可实现多人、多PC、多身份方式的登入和使用，涵盖了团餐生产中的大部分关键流程，包括了生产管理、采购管理、库存管理、品质管理和稽查管理等生产业务的主流程。同时，通过随时的查询和报表生成，可实现可视化的生产数据管理，对生产决策起到巨大的帮助作用。另外，该系统也提供基础的其他综合业务能力，比如：咨询管理、市场管理、便利店等，也提供了基础的人事行政和财务出纳模块。在一定程度上，也支持了和其他业务系统的对接能力，以及系统管理和参数配置等。",
    "“团餐生产管理ERP系统”的基本框图",
    "该团餐系统的云端版本，可以更大范围的支持多个城市、多种移动终端等新的业务形式。在系统结构上，将采用移动互联网最典型的云端架构，在服务器上组建Docker主机，Docker主机上承载操作系统、中间件和数据库等，最终形成IT架构层。IT架构是底层最基础的Infra层。之上是数据层，这个层具备稳定、快速、高可靠的存储结构化数据和非结构化数据的能力，形成数据的大吞吐、高稳定、高可靠的存储能力。在数据之上，则是利用J2EE体系形成的业务支撑层，该层利用开放式的架构，灵活的组建运行和对外接口的能力。再之上，则是应用层，将各生产流程（包括生产管理、采购管理、库存管理、品质管理、稽查管理等）和辅助流程（咨询管理、市场管理、人事管理、财务管理、便利店）等。应用层之上是展示的界面层，可以通过不同的方式来展示界面，比如浏览器的web页面，或者Android，iOS的App等。为了整个体系的稳健运行，由安全支撑、运维体系、标准系统等3个组成整体的支撑体系，确保系统的健壮安全运行。",
    "“团餐生产管理ERP云端系统”的架构图"
  ],
  // 产品2
  text2:[
    "公司视频技术方面有深厚的积累，特别是在智能交通和3D人脸两个方面。" ,
    "在智能交通方面，具备行人、人骑车、车辆等的全覆盖识别能力。支持矢量和结构化分析，综合矢量特征和结构化信息进行基于深度学习的以图搜图的技术，可进行超高性能的分析。基于先进生物特征识别技术的人脸识别智能视频监控系统能够识别不同的物体，发现监控画面中的异常情况，并能够以最快和最佳的方式发出警报和提供有用信息，从而能够更加有效地协助安全人员处理危机，并最大限度地降低误报和漏报现象。同时支持单机、专用硬件、云端等多种使用模式。",
    "人骑车信息结构化",
    "视频结构化系统",
    "在此基础功能之上，通过系统整合，可实现假套牌车分析、轨迹时空研判、全功能车辆研判等。智能交通技术，已成功实施于“交通违法及事故检测项目-高快速路包”标段，以及澳门CCTV系统等多个项目。",
    "假套牌车分析",
    "澳门智能交通项目",
    "3D人脸识别技术作为一种新兴的生物特征识别技术，是一种依据人体面部特征的自动身份鉴别技术。人脸识别综合运用了数字图像/视频处理、模式识别、计算机视觉等多种技术。人脸识别技术在公共安全、人机交互等领域具有广泛的应用前景。在3D人脸方面，我们的3D人脸数字模型，使得三维人脸数字模型在任一方向（α、β、γ）的投影，与该模型对应的真人在同一方向（ α、β、γ）拍得的照片无限接近（光照条件、投影摄影对应参数一致），既包含三维深度场，还包含逐点配准的三维纹理场，最终使得3D人脸识别首位命中率远超2D人脸识别。该项目获得国家层面的支持，分别列入2013年科技部重大科学仪器专项和2018 年“互联网＋”重大工程和人工智能创新发展工程项目计划。"
  ],
  // 产品3
  text3:[
    "随着交通卡口的大规模联网，系统汇集了海量车辆通行记录信息。利用交通大数据和人工智能技术，可实时分析城市交通流量，调整红绿灯间隔，缩短车辆等待时间等举措，提升城市道路的通行效率。" ,
    "大数据分析算法可以根据城市民众的出行偏好、生活、消费习惯等方式，分析出城市人流、车流的迁移与城市建设及公众资源的数据。基于这些大数据的分析结果，为政府决策部门进行城市规划，特别是为公共交通设施的基础建设提供指导和借鉴。",
    "城市级的大数据和人工智能大脑，实时掌握着城市道路上通行车辆的轨迹信息，停车场的车辆信息以及小区的停车信息，能提前半个小时预测交通流量变化和停车位数量变化，合理调配资源、疏导交通，实现机场、火车站、汽车站、商圈的大规模交通联动调度，提升整个城市的运行效率，为居民的出行畅通提供保障。",
    "本公司的大数据技术可实现全天候多目标检测，分时段全流量统计，速度分析，挖掘道路路面结构化数据隐含的规律，按用户指定的时间空间范围，比如按不同时段的交通信息进行统计分析，按学校路段开学和假期进行不同的人流量统计分析等情形。基于这些数据，可实现基于历史统计的行车时间估算，拥堵时段规避，提前做好路径规划等。大数据技术已应用于深圳交警、东莞交警、澳门交通事务局等单位。",
    "交通大数据系统"
  ],
  // 产品4
  text4:[
    "由于现代化的智能建筑和建筑群体的不断涌现，综合布线和系统集成的适用场合和服务对象逐渐增多。目前主要有商业贸易型，综合办公类型，交通运输类型，新闻机构类型，工业企业的高科技业务楼等等；" ,
    "从另外的维度来看，系统集成行业覆盖医疗、教育、政府、金融、电信、制造、能源、交通和企业等行业；医疗系统集成主要涉及网络平台、HIS、LIS、PACS等业务系统集成；教育系统集成主要涵盖智慧校园、智慧教育等；政府行业系统集成主要涉及电子政务等。",
    "本公司在智能楼宇、智慧校园、智能交通等大型综合项目的集成能力，可以服务于政企等多个行业。典型案例有澳门银河综合结构化布线工程，共布线上万个端口。澳门威尼斯人四季酒店AP系统，设计安装部署2000多个AP。",
    "澳门银河综合结构化布线工程",
    "而在国内，则负责了航盛科技大厦智能化系统总包，酷派天安云谷产业园一期的计算机网络及无线覆盖、智能化系统，北理工深圳创新大厦智能化总包，珠海昌安假日酒店、珠海市昌安国际酒店、珠海庆华酒店…等几十个项目。"
  ],
  // 页面导航
  Pages:'页面导航',
  //关于我们
  companyProfile:'公司简介',
  companyViews:'公司风貌',
  About: "颢腾集团是植根于粤港澳大湾区的高新技术企业集团，包括了澳门颢腾科技发展有限公司，珠海市颢腾智胜科技有限公司，珠海市智胜慧通科技有限公司，深圳市智胜慧通科技有限公司等企业。总部位于珠海市高新区港湾一号科创园园区。主要提供移动互联网服务给中国大陆、港澳等垂直领域的头端企业。",
  img:[
    {src: require("@/assets/img/pic/pic_about_img.jpg"),name:"公司前台"},
    {src: require("@/assets/img/title/style2.png"),name:"公司接待区"},
    {src: require("@/assets/img/title/style3.png"),name:"公司办公区"},
  ],
  introduce: [
    "颢腾集团是植根于粤港澳大湾区的高新技术企业集团，包括了澳门颢腾科技发展有限公司，珠海市颢腾智胜科技有限公司，珠海市智胜慧通科技有限公司，深圳市智胜慧通科技有限公司等企业。总部位于珠海市高新区港湾一号科创园园区。主要提供移动互联网服务给中国大陆、港澳等垂直领域的头端企业。",
    "集团在视频技术、大数据技术、软件开发及集成、系统集成等业务方向有丰富的经验。自主研制的以精准车辆识别与视频检测技术为核心的地面智慧交通管理系统、交通监控系统也已经广泛运用于全国各地及澳门的城市交通领域中。自主研发的团餐生产管理系统已应用于大型团餐生产企业，取得显著的生产率和效益提升。",
    "集团拥有一支博士、硕士学位和高级技术职称的研发、系统集成和客户服务队伍，有强大的技术创新与科研成果转化能力，拥有多项专利及软件著作权，已有产业资本——上市公司川大智胜参股。",
  ],
  msg:[
    {figure:10,unit:'年',content:'行业领先者产品创意丰富、实用'},
    {figure:22,unit:'个',content:'大中城市服务遍及全国各地'},
    {figure:59,unit:'家',content:'知名企业成为战略合作合并'},
    {figure:65,unit:'个',content:'解决方案个性化定制服务'}
  ],
  //联系我们
  ContactTitle:'联系我们',
  ContactUs: [
    {name: "电话", val: "(0756) 3613 109"},
    // {name: "电子邮箱", val: ""},
    {name: "邮编", val: "519000"},
    // {name: "公司传真", val: ""},
    {name: "联系地址", val: "珠海市高新区金唐路1号港湾1号科创园港8栋5楼"}
  ],
  ContactUs2: [
    {name: "电话", val: " (853) 2855 5169"},
    {name: "公司传真", val: "(853) 2855 5147"},
    {name: "联系地址", val: "澳门北京街230号澳门金融中心6层C座"}
  ],
  ContactUs3: [
    {name: "电话", val: " (852) 2667 8611"},
    {name: "公司传真", val: "(852) 2363 5033"},
    {name: "联系地址", val: "香港湾仔轩尼诗道303号协成行湾仔中心1602室"}
  ],
  // 招贤纳士
  JobsText:'颢腾集团旗下公司是提供移动互联网服务的高新企业，总部位于珠海市高新区金唐路1号港湾一号科创园园区。由在互联网领域工作多年的技术专家组成，在深圳，澳门等地设有分支机构。主要服务于中国大陆，港澳等垂直领域的头端企业。现招聘/Android开发/iOS开发/服务器前端开发/服务器后端开发/UX设计/网络工程师/安全专家/运维管理/产品经理/等员工。发展空间无限，待遇从优！请将简历发送到 <span style="color: royalblue">hr@houtang.net</span> 。我们期待你的加入！',

};



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js